package fr.frux.feature.map

import fr.frux.shared.domain.model.MapFilter
import fr.frux.shared.domain.model.Tree

/**
 * Mémoire du dernier lot chargé, sortie de [MapViewModel] (ratchet detekt `LargeClass`).
 *
 * Le dernier lot non vide sert au bouton « me localiser » : après un déplacement vers une zone sans
 * arbres, le lot affiché est vide et la personne attend de revoir ce qu'elle avait sous les yeux.
 */
internal class LoadedBatchMemory {
    /** Dernier lot non vide. Un lot vide ne l'écrase jamais. */
    var trees: List<Tree> = emptyList()
        private set

    /** Filtre de [trees] : ne jamais restaurer un lot sous des chips qui le contredisent. */
    var filter: MapFilter = MapFilter.None
        private set

    /**
     * Le dernier lot a-t-il été coupé par le plafond serveur. Zoomer n'a d'intérêt que dans ce cas :
     * sur un lot complet, tout est déjà à l'écran.
     */
    var truncated: Boolean = false

    fun remember(
        trees: List<Tree>,
        filter: MapFilter,
    ) {
        if (trees.isEmpty()) return
        this.trees = trees
        this.filter = filter
    }

    fun reset() {
        trees = emptyList()
        filter = MapFilter.None
        truncated = false
    }
}
